import React, { useState } from 'react'
import {Button,Modal} from 'react-bootstrap'

const style = {
    "buttonSpace":{
        "margin-top": '10px',
        "margin-right": '10px'
    }
}

function ModalAbout () {
    
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <div style={style.buttonSpace}>
            <Button variant="outline-primary" onClick={handleShow} >
                Learn more
            </Button>
            
            <Modal show={show} onHide={handleClose} animation={false}>
            <Modal.Header closeButton>
                <Modal.Title>About</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Melalui event Hackathon ini, PT PP (Persero) Tbk ingin memulai gerakan kesadaran digitalisasi. Hal ini disebabkan adopsi digital pada sektor konstruksi jauh lebih lambat dibandingkan dengan sektor lainnya. Sebagai sendi dan cara kerja baru dunia konstruksi di Indonesia, event ini diharapkan untuk menyelesaikan permasalahan yang dihadapi di dunia konstruksi khususnya PT PP dengan cara digitalisasi.
            PT PP (Persero) Tbk mengundang seluruh developer TI, startup, pelajar dan professional di Indonesia untuk berpatisipasi di Digital Construction Hack 2019 TANPA DIPUNGUT BIAYA APAPUN.
            Saatnya bereksplorasi dan berikan solusi inovatif yang mampu menjawab tantangan yang dihadapi bidang konstruksi.
            </Modal.Body>
            {/* <Modal.Footer></Modal.Footer> */}
            </Modal>
        </div>
    );
}


export default ModalAbout
